<template>
    <div class="create-new-print-item button" :class="{'is-loading': isUploadProcessing}">
        <input @change="processFile(null)" type="file" id="3d-file" hidden ref="fileInput">
        <span @click=selectFile() class="link link-primary">
            <slot></slot>
        </span>
    </div>
</template>

<script>
import {orderProcess} from "../../store/constants/order-process";

export default {
    name: "CreateNewPrintItemButton",
    data() {
        return {
            isUploadProcessing: false,
            file: null,
        }
    },
    computed: {
        currentOrderProcessStep: {
            get() {
                return this.$store.getters['currentOrderProcessStep'];
            },
            set(orderProcessStep) {
                this.$store.dispatch('setCurrentOrderProcessStep', orderProcessStep);
            }
        },
        currentConfigure3DStep : {
            get() {
                return this.$store.getters['currentConfigure3DStep'];
            },
            set(configure3DStep) {
                this.$store.dispatch('setCurrentConfigure3DStep', configure3DStep);
            }
        },
    },
    methods: {
        selectFile() {
            let clickEvent = new MouseEvent("click", {
                "view": window,
                "bubbles": true,
                "cancelable": false
            });
            this.$refs.fileInput.dispatchEvent(clickEvent);
        },
        processFile(file) {
            let vm = this;

            vm.isUploadProcessing = true;
            vm.file = file || this.$refs.fileInput.files[0];

            setTimeout(() => {
                vm.$store.dispatch("upload3DFile", {file: vm.file}).then(() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                    vm.isUploadProcessing = false;
                    vm.currentOrderProcessStep = orderProcess.STEPS.CONFIGURE_MODEL;
                    vm.$store.dispatch('setCheckoutVisibility', true);
                    vm.currentConfigure3DStep = 0;
                    vm.$router.push('/');
                }).catch(() => {
                    vm.isUploadProcessing = false;
                });
            }, 500);

        },
    }
}
</script>

<style scoped>

</style>